import React from "react";
import styled from "styled-components";
import QuantityControl from "./quantityControl";

const CartItem = ({
  title,
  image,
  quantity,
  isSelected,
  background,
  increment,
  decrement,
  price,
  ...rest
}) => {
  return (
    <ProductContainer {...rest}>
      <VerticalBar />
      <ProductImageContainer>
        <ProductImage alt={title} src={image} />
      </ProductImageContainer>
      <ProductTitle>{title}</ProductTitle>
      <ProductTitle>{`GHS ${price}`}</ProductTitle>
      <QuantityControlHolder>
        <QuantityControl
          iconBackground={background}
          increment={increment}
          decrement={decrement}
          value={quantity}
          isCompact
        />
      </QuantityControlHolder>
    </ProductContainer>
  );
};

const VerticalBar = styled.div`
  background-color: #00678f;
  width: 6px;
  height: 80%;
  height: 40px;
  position: absolute;
  left: -2px;
  border-radius: 5px;
`;

const ProductContainer = styled.div`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 15px 10px;
    border-radius: 20px;
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
    width: 100%,
    max-width: 313px;
    position: relative;
    margin-bottom: 16px;
    overflow-x: hidden;
`;

const ProductTitle = styled.div`
  font-family: "MTNMedium";
  font-size: 10px;
  padding-left: 5px;
  width: 60%;
  flex-grow: 1;
  box-sizing: border-box;
`;

const ProductImage = styled.img`
  object-fit: contain;
  object-position: center center;
  width: 52px;
  height: 52px;
`;

const ProductImageContainer = styled.div`
  width: 52px;
  height: 52px;
  margin: 0 10px;
`;

const QuantityControlHolder = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px 0 8px;
`;

export default CartItem;
